<template>
  <section class="basic-info card">
    <h3 class="title">{{ $t('product_brief') }}</h3>
    <p class="py-4 whitespace-pre-wrap" v-html="props.product?.description"></p>
    <!-- <template v-if="props.product?.vip_reward">
      <hr class="my-4" />
      <h3 class="title">白金會員</h3>
      <p class="py-4 whitespace-pre-wrap" v-html="props.product?.vip_reward"></p>
    </template> -->
  </section>
</template>

<script setup lang="ts">
import type { UiProductInfo } from '@/types/product'

const props = defineProps<{
  product: UiProductInfo
}>()
</script>

<style lang="scss" scoped></style>
